import { inject, Injectable } from '@angular/core';
import { Logo } from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  ApplicationConfig,
  checkStringValueNull,
  DarkSiteAem,
  HeaderFooterMachCore
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';

@Injectable({
  providedIn: 'root'
})
export class LogoAdapterService {
  appConfig = inject(ApplicationConfig);
  isDarkSiteEnabled = false;
  darkSiteThemeContent!: DarkSiteAem;

  getContent(content: HeaderFooterMachCore): Logo {
    this.checkDarkSiteEnabled(content);
    return {
      logo: {
        mainLogo: checkStringValueNull(content.logo?.mainLogo),
        mainLogoUrl: checkStringValueNull(content.logo?.mainLogoUrl),
        mainLogoNewTab:
          content.logo?.mainLogoNewTab !== 'false' &&
          content.logo?.mainLogoNewTab !== undefined,
        mainLogoAltText: checkStringValueNull(content.logo?.mainLogoAltText),
        businessLogo: checkStringValueNull(content.logo?.busiLogo),
        businessLogoUrl: checkStringValueNull(content.logo?.busiLogoUrl),
        businessLogoNewTab:
          content.logo?.busiLogoNewTab !== 'false' &&
          content.logo?.busiLogoNewTab !== undefined,
        businessLogoAltText: checkStringValueNull(
          content?.logo?.busiLogoAltText
        ),
        subLogo: checkStringValueNull(content.logo?.subLogo),
        subLogoUrl: checkStringValueNull(content.logo?.subLogoUrl),
        subLogoAltText: checkStringValueNull(content.logo?.subLogoAltText),
        subLogoExtLinkPopup:
          content.logo?.subLogoExtLinkPopup !== 'false' &&
          content.logo?.subLogoExtLinkPopup !== undefined
      }
    };
  }

  checkDarkSiteEnabled(content: HeaderFooterMachCore): void {
    if (!content?.darkSite) {
      return;
    }

    this.darkSiteThemeContent = content.darkSite;
    this.setDarkSiteState();
  }

  setDarkSiteState(): void {
    this.isDarkSiteEnabled = this.darkSiteThemeContent.isEnabled === 'true';
  }
}
